import {Injectable} from '@angular/core';

declare var WOW: any;

@Injectable()
export class WowService {
    init() {
        // console.log('WowService: Initializing WOW:', typeof WOW);
        if (typeof WOW !== 'undefined') {
            new WOW().init();
        }
    }
}
